module.exports = __webpack_public_path__ + "img/descend-3.8d246ed0.png";